export default () => ({
    billingAddressSameAsShipping: true,
    shippingAddressId: "",
    billingAddressId: "",
});
